export * as Sales from '../../Sales/js/components';
